/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super()
      this.disclosure = this.closest('details')

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note')
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }

      this.init()
    }

    init() {
      this.debouncedHandleNoteChange = debounce(
        this.handleNoteChange.bind(this),
        300
      )
      this.addEventListener('keyup', this.debouncedHandleNoteChange)
      this.addEventListener('change', this.debouncedHandleNoteChange)

      this.buildOrderNote()
    }

    async buildOrderNote() {
      const customerNoteTextarea = this.querySelector('#cart-note')
      if (!customerNoteTextarea) return

      const response = await fetch('/cart.js')
      const cart = await response.json()

      let customNoteContent = ''

      cart.items.forEach((item) => {
        const productName = item.product_title
        const customDimensions = item.properties?.['Medidas personalizadas']

        if (customDimensions) {
          customNoteContent += `${productName}\n`
          customNoteContent += `Medidas personalizadas: ${customDimensions}\n\n`
        }
      })

      customNoteContent = customNoteContent.trim()
      this.customNote = customNoteContent

      const customerNote = customerNoteTextarea.value.trim()
      const delimiter = '\n\n--- Productos personalizados ---\n\n'

      const finalNote = customNoteContent
        ? `${customerNote}${delimiter}${customNoteContent}`.trim()
        : customerNote

      this.updateCartNote(finalNote)
    }

    handleNoteChange() {
      const customerNoteTextarea = this.querySelector('#cart-note')
      if (!customerNoteTextarea) return

      const customerNote = customerNoteTextarea.value.trim()
      const customNote = this.customNote || ''
      const delimiter = '\n\n--- Productos personalizados ---\n\n'

      const finalNote = customNote
        ? `${customerNote}${delimiter}${customNote}`.trim()
        : customerNote

      this.updateCartNote(finalNote)

      if (this.cartNoteToggle) {
        const label = customerNote
          ? theme.strings.editCartNote
          : theme.strings.addCartNote
        if (this.cartNoteToggle.textContent !== label)
          this.cartNoteToggle.textContent = label
      }
    }

    updateCartNote(note) {
      this.fetchRequestOpts.body = JSON.stringify({ note })
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts)
    }
  }

  customElements.define('cart-note', CartNote)
}
